// Get the div element with class "new-div"
const newDiv = document.querySelector('#shopify-product-reviews');
// Get the parent section element of the newDiv element
const parentSection = newDiv?.closest('section');

if (parentSection) {
  parentSection.style.backgroundColor = '#F3EDE0'; 
}

// Set the background color of the parent section element





//read more button for the lengthy text

// function addReadMore() {
//     const reviews = document.querySelectorAll(".spr-review-content-body");
//     for (let i = 0; i < reviews.length; i++) {
//       const review = reviews[i];
//       if (review.innerText.length > 100) {
//         const shortText = review.innerText.substring(0, 100) + "...";
//         const longText = review.innerText;
//         const readMoreHTML = `<span class="read-more">
//                                 <a href="javascript:void(0)">Read more</a>
//                               </span>`;
//         review.innerHTML = shortText + readMoreHTML;
//         const readMore = review.querySelector(".read-more a");
//         readMore.addEventListener("click", function () {
//           review.innerHTML = longText;
//         });
//       }
//     }
//   }

//   setTimeout(function() {
//     addReadMore();
//   }, 3000);

// Get all review contents
// Get all review contents
// const reviewBodies = document.querySelectorAll('.spr-review-content-body');

//   if (reviewBodies.length > 0) {
//     reviewBodies.forEach((body) => {
//       const pseudoElement = window.getComputedStyle(body, ':after');
//       if (pseudoElement !== null) {
//       const readMoreText = pseudoElement.getPropertyValue('content').replace(/"/g, '');
      
//       body.addEventListener('click', () => {
//         const maxHeight = body.style.maxHeight;
//         body.style.maxHeight = maxHeight === 'none' ? null : 'none';
//       });
//     }
//     });
//   }

// setTimeout(function() {
//   $('.spr-review-content-body').each(function() {
//     // var pseudoElement = window.getComputedStyle(this, ':after');
//     // if (pseudoElement !== null) {
//     //   var readMoreText = pseudoElement.getPropertyValue('content').replace(/"/g, '');
      
//     //   $(this).on('click', function() {
//     //     var maxHeight = $(this).css('max-height');
//     //     $(this).css('max-height', maxHeight === 'none' ? null : 'none');
//     //   });
//     // }
//     $(this).append('<div><a href="#">Read More</a></div>');

//   });
// }, 3500);


document.addEventListener('DOMContentLoaded', function() {
$("body").delegate(".spr-review-content-body", "click", function(){
  $(this).toggleClass('read-full');
});



});